import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

// theme
import { useTheme } from "../../../hooks";
import {
  Button,
  CurveHolder,
  StyledText,
} from "../../../components/common/basic";
import {
  AddButtonIcon,
  Calender,
  Curve,
  Gift,
  NewBackButton,
  ProfileIcon,
} from "../../../components/svgs";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

// hooks
import { useSubscriber } from "../../../hooks";
import { Box } from "../../../components/common";
import JusdgeIcon from "../../../components/svgs/jusdgeIcon";
import EventSurveyIcon from "../../../components/svgs/eventSurvey";

const ProfileScreen = () => {
  const { themeContext, theme } = useTheme();

  const {
    uploadProfilePhoto,
    setUsername,
    fetchUserProfile,
    userhandle,
    userProfilephoto,
    isSuccessUsername,
    setSuccessUsername,
  } = useSubscriber();
  const [image, setImage] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(true);
  // const [username, SetUserName] = useState("User");
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState();

  useEffect(() => {
    if (selectedFile) {
      setUploadSuccess(false);
      var reader = new FileReader();
      reader.readAsDataURL(selectedFile);
      reader.onloadend = function (e) {
        setPreview(reader.result);
      };
      // Go ahead and upload file
      uploadProfilePhoto(selectedFile).then((success) => {
        if (success) {
          setUploadSuccess(true);
        } else {
          // TODO: check for exact error
          setUploadSuccess(false);
          setPreview(false);
        }
      });
    }
  }, [selectedFile]);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "ProfileScreen",
        firebase_screen_class: "ProfileScreen",
      })
    );
  }, []);

  useEffect(() => {
    if (userProfilephoto) {
      setPreview(userProfilephoto);
    }
  }, [userProfilephoto]);

  const history = useHistory();

  const handleImageChange = (event) => {
    // setImage(URL.createObjectURL(event.target.files[0]));
  };

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  return (
    <>
      <MainHolder style={{ display: "flex", flexDirection: "column" }}>
        <Children>
          <BackButtonContainer
            onClick={() => {
              history.goBack();
            }}
          >
            <NewBackButton />
          </BackButtonContainer>
          <HeaderContent activeTheme={background}>
            <ProfilePicHolder>
              <ProfilePic style={{ position: "relative" }}>
                <input
                  type="file"
                  style={{
                    opacity: "0",
                    position: "absolute",
                    zIndex: 2,
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: "100%",
                  }}
                  name="photo"
                  accept="image/*"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
                {preview ? (
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      style={{
                        opacity: uploadSuccess ? "1" : "0.4",
                        position: "relative",
                        zIndex: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      src={preview}
                    />
                  </div>
                ) : (
                  <ProfileIcon width={35} height={35} />
                )}
                {/* <AddButtonHolder
                  type="file"
                  accept="image/*"
                  id="profile-pic"
                  capture="environment"
                  onClick={handleImageChange}
                  name=""
                /> */}

                <div
                  style={{
                    display: preview ? "none" : "block",
                    position: "absolute",
                    bottom: "20px",
                    right: 0,
                    height: "20px",
                    width: "20px",
                    zIndex: 1,
                  }}
                >
                  <AddButtonIcon />
                </div>
              </ProfilePic>
            </ProfilePicHolder>
            <StyledText color="white" size={20} style={{ marginBlockEnd: 0 }}>
              {userhandle ? `@${userhandle}` : "Not set"}
            </StyledText>
          </HeaderContent>

          <ButtonHolder>
            <Button
              onClick={() => {
                setShowEditForm(true);
              }}
              style={{
                marginInline: 20,
                marginBlock: 20,
                height: 30,
                width: "40%",
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
                display: "flex",
                cursor: "pointer",
              }}
              color={background}
            >
              <StyledText color={"white"}>{`Edit Username`}</StyledText>
            </Button>
          </ButtonHolder>
          <EditUsernameForm
            username={userhandle}
            background={background}
            saveUsername={setUsername}
            show={showEditForm}
            hide={() => setShowEditForm(false)}
            isSuccess={isSuccessUsername}
            setSuccess={setSuccessUsername}
          />
          <Box
            style={{
              display: "flex",
              flex: 1,
              backgroundColor: "white",
            }}
          >
            <MenuItem
              onClick={() => {
                history.push("/referral/");
              }}
            />
          </Box>
        </Children>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            backgroundColor: "white",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        ></Box>
      </MainHolder>
    </>
  );
};

const MenuItem = ({ onClick }) => {
  const history = useHistory();

  return (
    <div>
      <Box
        onClick={() => {
          onClick();
        }}
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "white",
          marginLeft: 20,
          padding: 5,
        }}
      >
        <Gift fill={"#F5821E"} />
        <Box
          style={{
            backgroundColor: "white",
            marginLeft: 10,
          }}
        >
          <StyledText style={{ margin: 0 }}>Refer friends</StyledText>
          <StyledText
            size={11}
            style={{ margin: 0, color: "#7F7F7F", fontFamily: "MTNRegular" }}
          >
            Earn data and gift vouchers.
          </StyledText>
        </Box>
      </Box>
      <div
        style={{
          height: 1,
          width: "90vw",
          backgroundColor: "#C8CBCB",
          alignSelf: "center",
          margin: 15,
          marginLeft: 20,
        }}
      />
      <Box
        onClick={() => {
          history.push("/privacy");
        }}
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "white",
          marginLeft: 20,
          padding: 5,
        }}
      >
        <JusdgeIcon fill={"#F5821E"} />
        <Box
          style={{
            backgroundColor: "white",
            marginLeft: 10,
          }}
        >
          <StyledText style={{ margin: 0 }}>Terms & Conditions</StyledText>
          <StyledText
            size={11}
            style={{ margin: 0, color: "#7F7F7F", fontFamily: "MTNRegular" }}
          >
            Read on our T&Cs for Pulse
          </StyledText>
        </Box>
      </Box>

      <div
        style={{
          height: 1,
          width: "90vw",
          backgroundColor: "#C8CBCB",
          alignSelf: "center",
          margin: 15,
          marginLeft: 20,
        }}
      />

      <Box
        onClick={() => {
          history.push("/event_survey");
        }}
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "white",
          // borderTop: "1px solid gray",
          marginLeft: 20,
          padding: 5,
        }}
      >
        <EventSurveyIcon fill={"#F5821E"} width="20" />
        <Box
          style={{
            backgroundColor: "white",
            marginLeft: 10,
          }}
        >
          <StyledText style={{ margin: 0 }}>Take survey</StyledText>
          <StyledText
            size={11}
            style={{ margin: 0, color: "#7F7F7F", fontFamily: "MTNRegular" }}
          >
            Share your feedback to help us improve!
          </StyledText>
        </Box>
      </Box>
    </div>
  );
};

const EditUsernameForm = ({
  username,
  background,
  saveUsername,
  show,
  hide,
  setSuccess,
  isSuccess,
}) => {
  const [handle, setHandle] = useState();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [validHandle, setValidHandle] = useState(false);

  const handleChange = (e) => {
    setValidHandle(/^[a-zA-Z0-9_]{1,15}$/.test(e.target.value));
    setHandle(e.target.value);
  };
  const handleSubmit = () => {
    // Validate handle
    if (!loading && handle && /^[a-zA-Z0-9_]{1,15}$/.test(handle)) {
      setLoading(true);
      saveUsername(handle);
    }
  };

  useEffect(() => {
    setLoading(false);
    if (isSuccess === true) {
      setErrorMessage(null);
      hide();
    } else if (isSuccess === false) {
      setErrorMessage(`${handle} has already been taken`);
    }
    setSuccess(null);
  }, [isSuccess, setSuccess]);

  useEffect(() => {
    if (username) setHandle(username);
    if (/^[a-zA-Z0-9_]{1,15}$/.test(handle)) setValidHandle(true);
  }, [username]);

  return (
    <>
      {show && (
        <EditUsernameFormDialog>
          <EditUsernameDrop onClick={() => hide()} />
          <div
            style={{
              background: "#fff",
              position: "relative",
              paddingTop: "20px",
              height: "100%",
            }}
          >
            <StyledText>{`Enter new username`}</StyledText>
            <StyledTextInput
              type="text"
              placeholder={username || ""}
              value={handle}
              style={{
                color: validHandle ? "inherit" : "red",
                borderColor: validHandle ? "inherit" : "red",
              }}
              onChange={handleChange}
            />
            <p
              style={{
                color: "red",
                fontFamily: "MTNRegular",
                fontSize: "11px",
                visibility: errorMessage ? "visible" : "hidden",
              }}
            >
              {errorMessage}{" "}
            </p>
            <ButtonHolder>
              <Button
                onClick={handleSubmit}
                style={{
                  opacity: !validHandle || loading ? "0.5" : "1",
                  marginInline: 20,
                  marginBlock: 20,
                  height: 30,
                  width: "40%",
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                  display: "flex",
                  cursor: "pointer",
                }}
                color={background}
              >
                <StyledText color={"white"}>
                  {loading ? "Saving..." : `Save`}
                </StyledText>
              </Button>
            </ButtonHolder>
          </div>
        </EditUsernameFormDialog>
      )}
    </>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: #fff;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const EditUsernameFormDialog = styled.div`
  height: 100%;
  box-sizing: border-box;
  text-align: center;
  padding-top: 20%;
  width: 100%;
  position: absolute;
  z-index: 3;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const StyledTextInput = styled.input`
  padding: 10px;
  outline: none;
  font-family: MTNRegular;
  border: 1px solid #999;
  border-radius: 7px;
  min-width: 200px;
  width: 80%;
  text-align: center;
`;

const EditUsernameDrop = styled.div`
  position: absolute;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  top: 0;
  left: 0;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin: 8px;
  top: 20px;
  position: fixed;
`;

const HeaderContent = styled.div`
  display: flex;
  align-content: center;
  background-color: ${({ activeTheme }) => activeTheme};
  flex-direction: column;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 25px;
  min-height: 250px;
  justify-content: center;
  align-items: center;
`;

const ProfilePicHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
`;

const ProfilePic = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AddButtonHolder = styled.input`
  /* visibility: hidden; */
  &:before {
    content: "select";
    display: inline-block;
    width: 23;
    height: 23;
    background-color: white;
    border-radius: 50%;
  }
`;

const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default ProfileScreen;
